import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDirectors } from "./directorsSlice";
import { useParams, useLocation } from "react-router-dom";

const useDirectorsForm = (steps) => {
  const [showDirectorsRegistration, setShowDirectorsRegistration] =
    useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [endDate, setEndDate] = useState();
  const [secondEndDate, setSecondEndDate] = useState();
  const [cancelAppointment, setCancelAppointment] = useState(false);
  const [apiCall, setApiCall] = useState(true);
  const [editMessage, setEditMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { id, entityid } = useParams();
  const location = useLocation();
  const { current: roles } = useRef([
    {
      name: "Director",
      code: "Director",
    },
    { name: "Managing Director", code: "Managing Director" },
    { name: "Nominee Director", code: "Nominee Director" },
    { name: "Resident Director", code: "Resident Director" },
  ]);

  const directors = useSelector((state) => state.directors);
  const generalStatus = useSelector((state) => state.directors.status);
  const directorsArr = directors.directorsData;

  useEffect(() => {
    const currentLocation = location.pathname.split("/")[3];
    if (generalStatus === "idle" && currentLocation === "directors") {
      dispatch(fetchDirectors(id ? id : entityid));
    }
  }, [dispatch, id, generalStatus]);

  useEffect(() => {
    const currentLocation = location.pathname.split("/")[3];
    if (directorsArr && currentLocation === "directors") {
      dispatch(fetchDirectors(id ? id : entityid));
    }
  }, [apiCall, dispatch, id, entityid]);

  useEffect(() => {
    setActiveIndex(0);
  }, []);

  const handleBack = () => {
    setActiveIndex((prevActiveStep) => Math.max(prevActiveStep - 1, 0));
  };

  const handleNext = () => {
    setActiveIndex((prevActiveStep) =>
      Math.min(prevActiveStep + 1, steps.length - 1),
    );
  };

  const handleDirectorClick = () => {
    setShowDirectorsRegistration(true);
  };

  const positions = [
    { name: "Executive Director", code: "Executive Director" },
    { name: "Non-Executive Director", code: "Non-Executive Director" },
    { name: "Managing Director", code: "Managing Director" },
  ];

  const showDeleteModal = () => {
    setCancelAppointment(true);
  };

  return {
    handleDirectorClick,
    showDirectorsRegistration,
    handleBack,
    handleNext,
    activeIndex,
    endDate,
    setEndDate,
    positions,
    cancelAppointment,
    setCancelAppointment,
    showDeleteModal,
    directorsArr,
    setApiCall,
    editMessage,
    setEditMessage,
    secondEndDate,
    setSecondEndDate,
    loading,
    setLoading,
    roles,
  };
};

export default useDirectorsForm;
